import React from "react";

const video = require("../assets/first_change_bee.mp4");

const InitVideo = ({ toggleModel }) => {
  const videoEnded = () => {
    toggleModel();
  };

  return (
    <div
      style={{ display: "block", background: "rgb(204 204 204 / 68%)" }}
      className="modal fade show"
      id="exampleModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-body">
            <button
              onClick={() => toggleModel()}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div>
              <video onEnded={videoEnded} width="100%" autoPlay muted>
                <source src={video} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InitVideo;
